// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { setAntennaDetails, setRadioDetails } from '../helpers'
import { loadingToggler } from 'redux/modules/loading'
import { assignEntityDetails } from 'redux/modules/databaseDetails'

const setCurrentEntity = (dbSet, entityId) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const dbSetsMap = {
        antenna: setAntennaDetails,
        radio: setRadioDetails,
      }

      const entityDetails = await dispatch(dbSetsMap[dbSet](entityId))

      if (!entityDetails) {
        // if we're here, that means that the user has does not have adequate permissions
        // and has tried to access an entity which doesn't exist or is trying to access a new entity form.
        // return an empty object so the component doesn't update itself with anything
        // while react-router handles directing the user to a good page.
        return {}
      }

      await dispatch(assignEntityDetails(entityDetails))
      return entityDetails
    })
  )
)

export default setCurrentEntity
